// extracted by mini-css-extract-plugin
export default {"statisticsWrapper":"DiagramTab_statisticsWrapper__9c-ov","statisticsHeader":"DiagramTab_statisticsHeader__KROOu"};